import React from 'react';
import { Row, Col, Typography } from 'antd';
import logo from '../../assets/logo-02.svg';
import { SUPPORT_EMAIL, SUPPORT_PORTAL_URL } from '../supportDetails';
import './Footer.css';

import { Link } from "react-router-dom";

const { Text } = Typography;
// const navItems = ['Home', 'Features', 'Peg Board', 'Pricing', 'FAQs'];
const navItems = [
  { key: '1', label: 'Home', link : '/' },
  { key: '2', label: 'Features', link : '/features/managers' },
  { key: '8', label: 'Compare', link : '/compare' },
  { key: '3', label: 'Peg Board', link : '/pegboard' },
  { key: '4', label: 'Pricing', link : '/pricing' },
  { key: '5', label: 'Pulse', link : '/pulse' },
  { key: '6', label: 'FAQs', link : '/faq' },
  { key: '7', label: 'About', link : '/about' },
];

const scrollToTopOnPlainClick = (event) => {
  if (!event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
    document.getElementById('root').scrollTo(0, 0);
  }
};

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <Row className="footer-top" justify="space-between" align="middle">
          <Col xs={24} sm={6}>
            <div className="footer-logo-wrapper">
              <img src={logo} alt="ShuttleOps" className="footer-logo" />
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <nav className="footer-nav">
              {navItems.map(item => (
                <Link key={item.key}
                  to={item.link}
                  className="footer-nav-item"
                  onClick={scrollToTopOnPlainClick}
                  >
                  {item.label}
                </Link>
              ))}
            </nav>
          </Col>
        </Row>
        <div className="footer-divider" />
        <Row className="footer-bottom" align="middle" justify="space-between" gutter={[0, 24]}>
          <Col xs={24} md={12}>
            <Text className="footer-copy-text">
              © { new Date().getFullYear() } Westwood Artificial Intelligence Ltd. All rights reserved.
            </Text>
          </Col>
          <Col xs={24} md={12} align="right">
            <nav className="footer-legal" aria-label="Legal and support links">
              <Link to="/terms" className="footer-nav-item" onClick={scrollToTopOnPlainClick}>Terms</Link>
              <Link to="/privacy" className="footer-nav-item" onClick={scrollToTopOnPlainClick}>Privacy Policy</Link>
              <a href={SUPPORT_PORTAL_URL} className="footer-nav-item">Support</a>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="footer-nav-item">{SUPPORT_EMAIL}</a>
              <a href="https://tin.computer" className="footer-nav-item tin-credit">
                <span className="tin-mark" aria-hidden="true" />
                Growth by Tin
              </a>
            </nav>
          </Col>
        </Row>
      </div>
    </footer>
  );
}

export default Footer;
